import { productRepository } from "../repository/ProductRepository";

export const productService = {
  getLatestProducts: async (page, onSuccess, onError) => {
    productRepository
      .findLatest(page)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  getProductById: async (id, onSuccess, onError) => {
    productRepository
      .findById(id)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  getNProductByCategory: async (categoryId, N, onSuccess, onError) => {
    productRepository
      .findByNByCategory(categoryId, N)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  getProductsByFlag: async (flag, page, onSuccess, onError) => {
    productRepository
      .findByFlag(flag, page)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  searchProducts: async (query, page, onSuccess, onError) => {
    productRepository
      .search(query, page)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  getSales: async (onSuccess, onError) => {
    productRepository
      .getSales()
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  getProductCount: async (onSuccess, onError) => {
    productRepository
      .getProductCount()
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  addProduct: async (details, onSuccess, onError) => {
    productRepository
      .create(details)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  updateProduct: async (productId, details, onSuccess, onError) => {
    productRepository
      .update(productId, details)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  deleteProduct: async (productId, onSuccess, onError) => {
    productRepository
      .delete(productId)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
};
